import { render, staticRenderFns } from "./LayoutEmptyPage.vue?vue&type=template&id=1f674ecf&scoped=true&"
import script from "./LayoutEmptyPage.vue?vue&type=script&lang=js&"
export * from "./LayoutEmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f674ecf",
  null
  
)

export default component.exports